import { default as Utils } from './utils/base.Utils.js';
import { default as Errors } from './errors/base.Errors.js';

export default class BaseApp {

    set localStrings(strings) {
      this._localStrings = strings;
      this.onLanguageChanged();
     }
    get localStrings() { return this._localStrings[Utils.Language.getUserLanguage()]; }

    constructor() {

        window.addEventListener('error', (e) => {
            //catch only code unhadled errors
            Utils.Logger.log(e.Type, e.Message);

            this.manageException(e, e.Message);

            return false;
        });
    }

    manageException(error, message) {
        throw new Errors.Custom(Errors.Types.NOT_IMPLEMENTED_ERROR, 'manageException must be implemented');
    }

    onLanguageChanged() {
      moment.locale(Utils.Language.getUserLanguage());
      kendo.culture(Utils.Language.getUserLanguage() == 'it' ? 'it-IT' : 'en-US');
      kendo.bind($('head'), this.localStrings);
      kendo.bind($('body'), this.localStrings);
    }
}
